import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Container,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

import "./styles.scss";

const pilotFeatures = [
  'API access to Trade Compliance OS',
  'Sandbox semantic extraction testing',
  'Simulated Ledger Allocations',
  'Architecture evaluation support',
];

const enterpriseFeatures = [
  'Full 19 CFR deterministic math engine',
  'Live MT103 & Conditional Disbursements',
  'Dedicated AI compute instances',
  'Cryptographic Form 28 Audit Dossiers',
];

const PricingPage = () => {
  const navigate = useNavigate();

  return (
    <Box className="pricing-page">

      <Box className="pricing-page__header">
        <Container maxWidth="md">
          <Typography className="pricing-page__title">
            Platform Access & Deployment
          </Typography>
          <Typography className="pricing-page__subtitle">
            LusidPay provides programmable compliance and treasury infrastructure
            for B2B and B2G environments. Access is structured by deployment phase.
          </Typography>
        </Container>
      </Box>

      <Container maxWidth="lg" className="pricing-page__plans">
        <Grid container spacing={4} justifyContent="center">

          {/* Infrastructure Pilot */}
          <Grid item xs={12} md={6}>
            <Box className="pricing-card pricing-card--standard">
              <Box className="pricing-card__body">
                <Typography className="pricing-card__name">
                  Infrastructure Pilot
                </Typography>
                <Typography className="pricing-card__label pricing-card__label--sky">
                  Sandbox Environment
                </Typography>
                <Typography className="pricing-card__description">
                  For enterprise architecture teams and government agencies
                  evaluating agentic AI compliance workflows.
                </Typography>
              </Box>

              <List className="pricing-card__features" disablePadding>
                {pilotFeatures.map((feature) => (
                  <ListItem key={feature} disableGutters className="pricing-card__feature-item">
                    <ListItemIcon className="pricing-card__check pricing-card__check--muted">
                      <CheckIcon />
                    </ListItemIcon>
                    <ListItemText
                      primary={feature}
                      className="pricing-card__feature-text"
                    />
                  </ListItem>
                ))}
              </List>

              <Button
                fullWidth
                variant="outlined"
                className="pricing-card__btn pricing-card__btn--standard"
              >
                Request Sandbox
              </Button>
            </Box>
          </Grid>

          {/* Enterprise Deployment */}
          <Grid item xs={12} md={6}>
            <Box className="pricing-card pricing-card--highlight">
              <Box className="pricing-card__badge">Production</Box>

              <Box className="pricing-card__body">
                <Typography className="pricing-card__name">
                  Enterprise Deployment
                </Typography>
                <Typography className="pricing-card__label pricing-card__label--sky">
                  Live Multi-Node Settlement
                </Typography>
                <Typography className="pricing-card__description">
                  For Large Importers, Forwarders, and Customs Brokers executing
                  live 19 CFR deterministic math and MT103 wire settlements.
                </Typography>
              </Box>

              <List className="pricing-card__features" disablePadding>
                {enterpriseFeatures.map((feature) => (
                  <ListItem key={feature} disableGutters className="pricing-card__feature-item">
                    <ListItemIcon className="pricing-card__check pricing-card__check--sky">
                      <CheckIcon />
                    </ListItemIcon>
                    <ListItemText
                      primary={feature}
                      className="pricing-card__feature-text"
                    />
                  </ListItem>
                ))}
              </List>

              <Button
                fullWidth
                variant="contained"
                className="pricing-card__btn pricing-card__btn--highlight"
                onClick={() => navigate('/contact-us')}
              >
                Contact Sales
              </Button>
            </Box>
          </Grid>

        </Grid>
      </Container>

    </Box>
  );
};

export default PricingPage;
